import { render, staticRenderFns } from "./mapLoca.vue?vue&type=template&id=1c923d07&"
import script from "./mapLoca.vue?vue&type=script&lang=js&"
export * from "./mapLoca.vue?vue&type=script&lang=js&"
import style0 from "./mapLoca.vue?vue&type=style&index=0&id=1c923d07&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports